import React from 'react';

// eslint-disable-next-line
const PushNotification = ({ notification }: any): React.ReactElement => {
  return (
    <>
      <div id="notificationHeader">
        {/* image is optional */}
        {notification.image && (
          <div id="imageContainer">
            <img
              alt={notification.title}
              src={notification.image}
              width={100}
            />
          </div>
        )}
        <span>{notification.title}</span>
      </div>
      <div id="notificationBody">{notification.body}</div>
    </>
  );
};

export default PushNotification;
